






























































import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { fetchConfiguracionStreamax } from './../fetchConfiguracionStreamax';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { EstadoEntidad } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import { GridApi } from 'ag-grid-community';
import { consoleSandbox } from '@sentry/utils';
@Component({
  components: {
    DatePicker,
    TimePicker,
    'app-confirmacion': Confirmation,
  },
})
export default class FormNetStreamStreamax extends Vue {
  @Prop({ default: false }) edited!: any;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({ default: {} }) selectedValue: any;
  @Prop({ default: {} }) usuario: any;
  accion!: any;
  ordesList2: any;
  data: any = {};
  headers: any[] = [
    { text: 'Canal', align: 'start', sortable: false, key: 'canal' },
    { text: 'Encode Standard', value: 'dato1', sortable: false },
    // ...
  ];
  tablaDatos: any[];

  onPropertyChanged() {
    this.tablaDatos = [
      {
        canal: '1',
        value1: 0,
        dato1: [{ label: 'H264', id: 0 }, { label: 'ON', id: 1 }],
      },
      {
        canal: '2',
        value1: 0,
        dato1: [{ label: 'H264', id: 0 }, { label: 'ON', id: 1 }],
      },
      {
        canal: '3',
        value1: 0,
        dato1: [{ label: 'H264', id: 0 }, { label: 'ON', id: 1 }],
      },
      {
        canal: '4',
        value1: 0,
        dato1: [{ label: 'H264', id: 0 }, { label: 'ON', id: 1 }],
      },
      {
        canal: '5',
        value1: 0,
        dato1: [{ label: 'H264', id: 0 }, { label: 'ON', id: 1 }],
      },
    ];
  }
  mounted() {
    this.onPropertyChanged();
  }
  //abstract
  readonly funcionalidad: Funcionalidades = Funcionalidades.Streamax;
  //propiedades globales
  loadingService = new LoadingService();
  gridApi: GridApi;
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  bottomNav: any = '1';
  dictionaryFormErrors: any = {};
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;
  //Interface
  estadoSwitch: boolean = false;
  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
}
